import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";

import {
  addUnit,
  obtenerUnits,
} from "../../../../API/Global/UnidadesMedida/UnitRequests";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import Loader from "../../../../Components/Loader/Loader";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";

const CrudUnitModal = ({
  toastRef,
  unidad,
  unidadesDialog,
  setUnidadesDialog,
  getUnidades,
  modo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [unidades, setUnidades] = useState([{}]);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdUnit: -1,
    Currency: "",
    CurrencySymbol: "",
    UnitDescription: "",
    IdStatus: unidad ? unidad?.IdStatus : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const estadosTempo = await getEstadosCategory("General");
    const unidades = await obtenerUnits();
    setEstados(estadosTempo);
    setUnidades(unidades);

    // Si el modo es "Crear", establece el primer estado como valor inicial
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === unidad?.IdStatus);

    setValues({
      ...unidad,
      Estado: estadoInicial,
      IdStatus: estadoInicial.IdStatus,
    });
    setLoading(false)
  };

  const onHide = () => {
    setUnidadesDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.UnitName) {
      error.UnitName = true;
      error.error = true;
    }
    if (!values.UnitSimbol) {
      error.UnitSimbol = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }if (!/^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\s.\-_]*$/.test(values.UnitDescription)) {
      error.UnitDescription = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarUnit = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const existingUnit = unidades.find(
        (unit) => unit.UnitName === values.UnitName
      );
      if (existingUnit && (modo === "Crear" || existingUnit.IdUnit !== values.IdUnit)) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe una unidad con ese nombre"
        );
      } else {
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdUnit: values?.IdUnit,
          UnitName: values.UnitName,
          UnitSimbol: values.UnitSimbol,
          UnitDescription: values.UnitDescription,
          IdStatus: estadoId,
          IdUserCreate: userAuth?.IdUser
        };

        // console.log(a)
        const resultado = await addUnit(a);

        if(resultado[0].ESTADO === 1){
          setLoading(true)
          toastShow(
            toast,
            "success",
            "Datos Agregados",
            resultado[0].MENSAJE
          );
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            resultado[0].MENSAJE
          );
          getUnidades()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1000);
        }else{
          toastShow(
            toast,
            "error",
            "Error",
            resultado[0].MENSAJE
          );
        }
      }
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        "Error, completa los campos requeridos."
      );
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Actualizar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarUnit();
          } else {
            agregarUnit();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (unidadesDialog) {
      getValoresIniciales();
    }
  }, [unidadesDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Unidad" : "Modificar Unidad";

  return (
    <div>
      <Dialog
        visible={unidadesDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <ConfirmDialog />
        <div id="UnitDialog">
          <Loader loading={loading} querySelector={"#UnitDialog"} />
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="UnitName"
                  value={values.UnitName}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.UnitName ? "p-invalid" : ""}
                />
                <label htmlFor="UnitName">Unidad de medida</label>
                {error.UnitName && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Campo Requerido.
                  </small>
                )}
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="UnitSimbol"
                  value={values.UnitSimbol}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                />
                <label htmlFor="UnitSimbol">Simbolo</label>
                {error.UnitSimbol && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Campo Requerido.
                  </small>
                )}
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="UnitDescription"
                  value={values.UnitDescription}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.UnitDescription ? "p-invalid" : ""}
                />

                <label htmlFor="UnitDescription">Descripción</label>
                {error.UnitDescription && (
                  <small className="p-error">
                    La Descripción solo puede contener letras, números,
                    espacios y los caracteres '.', '_', '-'.
                  </small>
                )}
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Estado ? "p-invalid" : ""}
                />
                {error.IdStatus && (
                  <small
                    className="p-error block"
                    style={{ position: "absolute", top: 41 }}
                  >
                    Campo Requerido.
                  </small>
                )}
              </span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CrudUnitModal;
